import { Bell } from "lucide-react";
import { Badge } from "../ui/badge";

/**
 * Badge alert somministrazioni del giorno (due/overdue).
 * @param {number} count totale alert
 * @param {number} [overdue] se > 0 usa stile "in ritardo"
 * @param {"sm"|"md"} [size]
 * @param {boolean} [showZero]
 * @param {string} [label] testo dopo il numero (default: terapia/e)
 */
export default function OssTerapiaAlertBadge({
  count = 0,
  overdue = 0,
  size = "sm",
  showZero = false,
  label,
  className = "",
}) {
  const n = Number(count) || 0;
  if (n <= 0 && !showZero) return null;
  const hasOverdue = (Number(overdue) || 0) > 0;
  const text =
    label != null
      ? label
      : n === 1
        ? "terapia"
        : "terapie";
  const sizeClass =
    size === "md"
      ? "text-xs px-2 h-6 gap-1"
      : "text-[10px] px-1.5 h-5 gap-0.5";

  return (
    <Badge
      className={`${hasOverdue ? "bg-red-600" : "bg-amber-500"} text-white font-semibold inline-flex items-center ${sizeClass} ${className}`}
      title={hasOverdue ? "Somministrazioni in ritardo o in scadenza" : "Somministrazioni in scadenza"}
    >
      <Bell className={size === "md" ? "w-3.5 h-3.5" : "w-3 h-3"} />
      <span className="tabular-nums">{n}</span>
      {text ? <span>{text}</span> : null}
    </Badge>
  );
}
